import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { montagePermissionsConst } from "../../constants/productionConstants";

// Shared montage duplication (edit view, main list, archive list): confirm,
// POST admin_duplicate, then open the copy's edit form. The copy has no order
// products and a reset production state, so it always lands on the main list.
export function useMontageDuplicate() {
  const store = useStore();

  // Duplicating creates a new montage, so it needs the add permission.
  const canDuplicateMontage = computed(() =>
    hasPermission(montagePermissionsConst.add)
  );
  // pk of the montage waiting for confirmation (false = modal closed).
  const duplicateConfirmPk = ref(false);
  const isDuplicating = ref(false);
  const duplicateMontageData = computed(
    () => store.getters.getDuplicateMontageData
  );

  const askDuplicateMontage = (pk) => {
    duplicateConfirmPk.value = pk;
  };

  const duplicateConfirmContent = computed(
    () =>
      "Czy na pewno chcesz zduplikować montaż o nr: <b>" +
      duplicateConfirmPk.value +
      "</b>? Kopia nie będzie zawierać przypisanych zleceń."
  );

  const duplicateMontage = () => {
    const pk = duplicateConfirmPk.value;
    duplicateConfirmPk.value = false;
    if (!pk || !canDuplicateMontage.value || isDuplicating.value) {
      return;
    }
    isDuplicating.value = true;
    store.dispatch("duplicateMontage", pk);
  };

  watch(
    () => duplicateMontageData.value,
    function (newValue) {
      // Ignore responses to a duplication started from another view.
      if (!newValue || !isDuplicating.value) return;

      if (newValue.status === 201) {
        store.dispatch("showToaster", {
          type: "success",
          content: "Montaż został zduplikowany!",
        });
        router.push({
          name: "MontagesEdit",
          params: { pk: newValue.data.pk },
        });
      } else {
        isDuplicating.value = false;
        store.dispatch("showToaster", {
          type: "error",
          content:
            newValue.data?.detail ??
            newValue.data?.non_field_errors?.[0] ??
            "Nie udało się zduplikować montażu.",
        });
      }
    }
  );

  return {
    canDuplicateMontage,
    duplicateConfirmPk,
    duplicateConfirmContent,
    isDuplicating,
    askDuplicateMontage,
    duplicateMontage,
  };
}
